// @ts-nocheck
import { oneOf, string } from 'prop-types'

import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import { BREAKPOINT_MAP, BREAKPOINTS } from 'views/consts/imgBreakpoints'
import { sizesPropType, srcSetPropType } from 'views/utils/propTypes/img'

import { transformSizes, transformSrcSet } from './helpers'

const SourcePropTypes = {
  minWidth: oneOf(BREAKPOINTS),
  type: string,
  sizes: sizesPropType.isRequired,
  srcSet: srcSetPropType.isRequired,
}

const SourceDefaultProps = {
  minWidth: null,
  type: null,
}

type SourceProps = InferPropsWithDefaults<
  typeof SourcePropTypes,
  typeof SourceDefaultProps
>

const Source = ({
  minWidth,
  type,
  sizes,
  srcSet,
  ...otherProps
}: SourceProps) => {
  return (
    <source
      media={BREAKPOINT_MAP[minWidth]}
      type={type}
      sizes={sizes ? transformSizes(sizes) : null}
      srcSet={srcSet ? transformSrcSet(srcSet) : null}
      {...otherProps}
    />
  )
}

Source.propTypes = SourcePropTypes
Source.defaultProps = SourceDefaultProps

export default Source
